import  './ServiceBookingForm.scss';

export default function ServiceBookingForm() {
    return (
      <>
        <div className="contact-form service-booking-form">
            <h2>Enquire about Servicing, MOTs and Repairs</h2>
            <form action="/booking-form/" method="GET" target="_blank" id="service-booking-form" className="enquiry-form">
            <div className="form-row">
                <div className="form-item hidden">
                <input type="hidden" name="id" placeholder="" value="{{ .Params.booking_tool_id }}" required />
                </div>
                <div className="form-item third">
                <input id="vrm" type="text" data-validation-error="Please enter a valid UK Registration"  pattern="(^[A-Za-z]{2}[0-9]{2}\s?[A-Za-z]{3}$)|(^[A-Za-z][0-9]{1,3}[A-Za-z]{3}$)|(^[A-Za-z]{3}[0-9]{1,3}[A-Za-z]$)|(^[0-9]{1,4}[A-Za-z]{1,2}$)|(^[0-9]{1,3}[A-Z]{1,3}$)|(^[A-Z]{1,2}[0-9]{1,4}$)|(^[A-Za-z]{1,3}[0-9]{1,3}$)|(^[A-Za-z]{1,3}[0-9]{1,4}$)|(^[0-9]{3}[DX]{1}[0-9]{3}$)" name="vrm" className="registration" placeholder="Your Reg" required />
                </div>
                <div className="form-item third">
                <input type="number" name="mileage" placeholder="Mileage*" required />
                </div>
                <div className="form-submit third">
                    <button type="submit">Look Up Vehicle</button>
                </div>
            </div>
            </form>
        </div>
  
      </>
    );
  }
  